module.exports = __webpack_public_path__ + "img/upload.7e9194f6.svg";